function parseValues(text) {
  return text
    .replace(/[^0-9.\-–]/g, '')
    .split(/[-–]/)
    .map(num => parseFloat(num.trim()))
    .filter(num => !isNaN(num));
}

function initDataset(elems) {
  for (let i = 0; i < elems.length; i++) {
    const elem = elems[i];
    const values = parseValues(elem.innerHTML.trim());
    if (values.length > 0) {
      const isHalf = values.map(v => v % 1 === 0.5 ? '1' : '0').join(',');
      elem.dataset.value = values.join('-');
      elem.dataset.isHalf = isHalf;
    }
  }
}

function formatValue(value, keepDecimal, unit) {
  const val = keepDecimal ? value.toFixed(1) : Math.round(value);
  return unit === "cm" ? val + ' cm' : val + '″';
}

function renderValues(unit, elems, cmEls, inchEls, switchEl) {
  for (let i = 0; i < elems.length; i++) {
    const elem = elems[i];
    if (!elem.dataset.value) continue;
    const values = elem.dataset.value.split('-').map(num => parseFloat(num)).filter(num => !isNaN(num));
    const isHalfArr = elem.dataset.isHalf.split(',').map(s => s === '1');
    const parts = values.map((v, idx) => {
      const keepDecimal = isHalfArr[idx];
      if (unit === "cm") {
        return formatValue(v, keepDecimal, "cm");
      } else {
        const inchVal = v * 0.393700787;
        return formatValue(inchVal, keepDecimal, "inch");
      }
    });
    elem.innerHTML = parts.join('–');
  }

  if (unit === "cm") {
    for (let i = 0; i < cmEls.length; i++) cmEls[i].classList.add('unit-cm__true');
    for (let i = 0; i < inchEls.length; i++) inchEls[i].classList.remove('unit-inch__true');
    switchEl.checked = true;
  } else {
    for (let i = 0; i < cmEls.length; i++) cmEls[i].classList.remove('unit-cm__true');
    for (let i = 0; i < inchEls.length; i++) inchEls[i].classList.add('unit-inch__true');
    switchEl.checked = false;
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const elems = document.querySelectorAll('#size-data td, #size-data a');
  const cmEls = document.querySelectorAll('.unit-cm');
  const inchEls = document.querySelectorAll('.unit-inch');
  const switchEl = document.querySelector('#unit-switch');
  const switchBtns = document.querySelectorAll('#unit-switch-btn-sc, #unit-switch-btn-sg');

  initDataset(elems);
  renderValues("cm", elems, cmEls, inchEls, switchEl);

  for (let i = 0; i < switchBtns.length; i++) {
    switchBtns[i].addEventListener('click', function() {
      const currentUnit = elems[0].innerHTML.includes('cm') ? 'cm' : 'inch';
      const targetUnit = currentUnit === 'cm' ? 'inch' : 'cm';
      renderValues(targetUnit, elems, cmEls, inchEls, switchEl);
    });
  }
});
